var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "flowNo",
                    expression: "'flowNo'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("flowNo"),
                  rules: _vm.getRules("flowNo"),
                  label: "编号",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.formData.flowNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "flowNo", $$v)
                  },
                  expression: "formData.flowNo",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssxm",
                  required: _vm.isRequired("ssxm"),
                  value: _vm.formData.ssxm,
                  rules: _vm.getRules("ssxm"),
                  label: "所属项目",
                  placeholder: "请选择项目",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssxm,
                            placeholder: "请选择项目",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssxm, "ssxm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssxm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssxm, "show", $$v)
                              },
                              expression: "ssxm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择项目",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssxm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmitSsxm("ssxm", {
                                    label: "projectName",
                                    value: "projectId",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssxm,
                                    "projectName"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssxm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssxm, "filterText", $$v)
                                },
                                expression: "ssxm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssxm",
                              attrs: {
                                duration: 0,
                                "value-key": "projectName",
                                columns: _vm.ssxm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssxm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qjlx",
                    expression: "'qjlx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "qjlx",
                  required: _vm.isRequired("qjlx"),
                  value: _vm.formData.qjlx,
                  label: "请假类型",
                  rules: _vm.getRules("qjlx"),
                  placeholder: "请选择请假类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.qjlx,
                            placeholder: "请选择请假类型",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.qjlx, "qjlx")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.qjlx.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.qjlx, "show", $$v)
                              },
                              expression: "qjlx.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择请假类型",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.qjlx.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("qjlx")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.qjlx)
                                },
                              },
                              model: {
                                value: _vm.qjlx.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.qjlx, "filterText", $$v)
                                },
                                expression: "qjlx.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "qjlx",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.qjlx.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.qjlx.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qjsj",
                    expression: "'qjsj'",
                  },
                ],
                attrs: {
                  value: _vm.formData.qjsj[0],
                  required: _vm.isRequired("qjsj"),
                  name: "qjsj",
                  label: "请假开始时间",
                  placeholder: "请假开始时间",
                  "input-align": "right",
                  rules: _vm.getRules("qjsj"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.qjsj[0]
                              ? `${_vm.formData.qjsj[0]}`
                              : "",
                            placeholder: "请假开始时间",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.qjsjStart, "qjsj")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.qjsjStart.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.qjsjStart, "show", $$v)
                              },
                              expression: "qjsjStart.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择请假开始时间",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.qjsjStart.show = false
                                },
                                "click-right": _vm.qjsjStartChange,
                              },
                            }),
                            _c("van-datetime-picker", {
                              ref: "qjsjStart",
                              attrs: {
                                "show-toolbar": false,
                                type: "datetime",
                                title: "选择完整时间",
                              },
                              model: {
                                value: _vm.qjsjStart.currentDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.qjsjStart, "currentDate", $$v)
                                },
                                expression: "qjsjStart.currentDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qjsj",
                    expression: "'qjsj'",
                  },
                ],
                attrs: {
                  value: _vm.formData.qjsj[1],
                  required: _vm.isRequired("qjsj"),
                  name: "qjsj",
                  label: "请假结束时间",
                  placeholder: "请假结束时间",
                  "input-align": "right",
                  rules: _vm.getRules("qjsj"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.qjsj[1]
                              ? `${_vm.formData.qjsj[1]}`
                              : "",
                            placeholder: "请假结束时间",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.qjsjEnd, "qjsj")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.qjsjEnd.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.qjsjEnd, "show", $$v)
                              },
                              expression: "qjsjEnd.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择请假结束时间",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.qjsjEnd.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.qjsjEndChange("qjsj")
                                },
                              },
                            }),
                            _c("van-datetime-picker", {
                              ref: "qjsjEnd",
                              attrs: {
                                "show-toolbar": false,
                                type: "datetime",
                                title: "选择完整时间",
                              },
                              model: {
                                value: _vm.qjsjEnd.currentDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.qjsjEnd, "currentDate", $$v)
                                },
                                expression: "qjsjEnd.currentDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qjsc",
                    expression: "'qjsc'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("qjsc"),
                  type: "number",
                  required: _vm.isRequired("qjsc"),
                  rules: _vm.getRules("qjsc"),
                  name: "qjsc",
                  maxlength: "50",
                  autosize: "",
                  label: "请假时长(天)",
                  placeholder: "请输入请假时长",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.qjsc,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "qjsc", $$v)
                  },
                  expression: "formData.qjsc",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qjsy",
                    expression: "'qjsy'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("qjsy"),
                  required: _vm.isRequired("qjsy"),
                  name: "qjsy",
                  rules: _vm.getRules("qjsy"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "请假事由",
                  "show-word-limit": "",
                  placeholder: "请输入请假事由",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.qjsy,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "qjsy", $$v)
                  },
                  expression: "formData.qjsy",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            staticClass: "m-t-20",
            attrs: {
              processData: _vm.processData,
              formData: _vm.formData,
              formItemMap: _vm.formItemMap,
            },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-50", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }